//2.1 is voor wat de feedback betreft//2.2 de file er terug uit voor vlot offline gebruik
//2.3 regionview met kaart en klikken

import { Typography } from '@mui/material'
import Paper from '@mui/material/Paper'
import Box from '@mui/system/Box'

/**
 * Not implemented yet
 *
 * @returns React component
 */
export const Strategy = () => {
  return (
    <Paper sx={{ p: 3, width: '80%' }}>
      <Typography variant="h4">Strategy</Typography>
      <Box sx={{ height: 5 }} />
      <Typography variant="body1">Not implemented yet</Typography>
    </Paper>
  )
}
